import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import DSCard from "views/system-design/DSCard";
import DSCircularProgress from "views/system-design/DSCircularProgress";
import useStudioCommits from "../hooks/useStudioCommits";

const StudioUpdates = () => {
  const { data: updates, isPending, error } = useStudioCommits();

  if (isPending) {
    return (
      <DSBox
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <DSCircularProgress />
      </DSBox>
    );
  }

  if (error) {
    return (
      <DSBox sx={{ p: 3 }}>
        <DSTypography color="error">
          Failed to load updates: {error.message}
        </DSTypography>
      </DSBox>
    );
  }

  if (!updates?.length) {
    return (
      <DSBox sx={{ p: 3 }}>
        <DSTypography color="text.secondary">
          No updates in the last 2 weeks.
        </DSTypography>
      </DSBox>
    );
  }

  return (
    <DSBox sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
      <DSTypography variant="h6" sx={{ mb: 1 }}>
        Recent Studio Updates
      </DSTypography>
      {updates.map((update) => (
        <DSCard key={update.url} sx={{ p: 2 }}>
          <a
            href={update.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <DSTypography
              sx={{
                fontWeight: 500,
                color: "primary.main",
                "&:hover": { textDecoration: "underline" },
                wordBreak: "break-word",
              }}
            >
              {update.message}
            </DSTypography>
          </a>
          <DSTypography
            variant="body2"
            sx={{ mt: 0.5, color: "text.secondary" }}
          >
            {new Date(update.date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </DSTypography>
        </DSCard>
      ))}
    </DSBox>
  );
};

export default StudioUpdates;
